import React, { type ReactElement, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { StoreStatus } from 'common/utils/types'
import CrashScreen from 'common/navigation/crash-screen'
import { getAuthUser } from 'common/authentication/auth.service'
import SplashScreen from 'common/ui/splash-screen'
import { useAppDispatch, useAppSelector } from 'store/hooks'

const SPLASH_SCREEN_MIN_TIME_MS = 1500

const InitialDataLoad = (): ReactElement => {
  const dispatch = useAppDispatch()
  const { initialLoadStatus } = useAppSelector((state) => state.auth)
  const [splashScreen, setSplashScreen] = useState(true)

  useEffect(() => {
    void dispatch(getAuthUser())
  }, [dispatch])

  useEffect(() => {
    setTimeout(() => {
      setSplashScreen(false)
    }, SPLASH_SCREEN_MIN_TIME_MS)
  }, [])

  return splashScreen ? (
    <SplashScreen />
  ) : (
    <>
      {initialLoadStatus === StoreStatus.Loading && <SplashScreen />}
      {initialLoadStatus === StoreStatus.Succeeded && <Outlet />}
      {initialLoadStatus === StoreStatus.Failed && <CrashScreen />}
    </>
  )
}

export default InitialDataLoad
